import { CommunityType } from "../lib/types/enums/community/communityType";
import type { Community } from "../lib/types/schema/community/communitySchema";

export type GetCommunityMemberCountProps = {
  community: Partial<Community>;
};

export const getCommunityMemberCount = ({
  community,
}: GetCommunityMemberCountProps) => {
  if (community?.type === CommunityType.network)
    return community?.member_summary?.network_member_count;

  return community?.member_summary?.member_count;
};
